import React from "react";
import "../components/styles/About.css";
export default function About() {
  return (
    <section className="page about-page">
      <h2>
        About <span className="highlight">Siara Marketing Pvt Ltd</span>
      </h2>

      <h3 className="sub-title">Building Digital Products With Purpose</h3>

      <p className="about-text">
        <strong>Siara Marketing Pvt Ltd</strong> is a modern mobile app
        development company dedicated to crafting fast, clean and intelligent
        applications. We create solutions that simplify everyday experiences for
        users and accelerate growth for businesses.
      </p>

      <p className="about-text">
        Our strength lies in combining <em>beautiful UI</em>,
        <em> intuitive UX</em>, and <em>high-performance engineering</em> to
        deliver apps that feel smooth, reliable and future-ready.
      </p>

      <blockquote className="quote">
        “We don’t just build apps — we build experiences that people remember.”
      </blockquote>

      <h3 className="sub-heading">What Defines Us</h3>

      <ul className="about-list">
        <li>Clean and user-centered app design</li>
        <li>High-performance development with modern tools</li>
        <li>Scalable architecture and cloud-backed systems</li>
        <li>Attention to detail and long-term support</li>
      </ul>
    </section>
  );
}
